enum VoucherType {
  CURRENCY = "currency",
  PRODUCT = "product"
}

export default VoucherType;